'use client';

import React from 'react';

import NotFoundError from '@/components/NotFoundError';

export default function NotFound() {
  return <NotFoundError></NotFoundError>;
}
